
export const STATUS_MAPPER = {
  active: 'accent',
  ignited: 'neutral',
  completed: 'success',
  pending: 'warning',
}

export const TYPE_MAPPER = {
  deals_only: 'Deals Only',
  points: 'Points',
}
